import { render } from "./AddContactModal.vue?vue&type=template&id=37f4799a&scoped=true"
import script from "./AddContactModal.vue?vue&type=script&lang=js"
export * from "./AddContactModal.vue?vue&type=script&lang=js"

import "./AddContactModal.vue?vue&type=style&index=0&id=37f4799a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f4799a"]])

export default __exports__